import { render, staticRenderFns } from "./MyPaymentMethods.vue?vue&type=template&id=6331df8c"
import script from "./MyPaymentMethods.vue?vue&type=script&lang=js"
export * from "./MyPaymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports